import { Component, Optional } from '@angular/core';
import {
  DetailViewWindowInfo,
  DynamicFormService,
  FORM_SERVICE_PROVIDER_TOKEN
} from '@ntap/common';
import {
  CoreConfigService,
  ItemViewProviderDirective,
  ViewProviderDirective,
  WindowInfo
} from '@ntap/core';
import {
  injectedOrDefaultFormServiceFactory,
  PrimeNGCommonItemViewComponent
} from '@ntap/primeng';
import { take } from 'rxjs';

@Component({
  selector: 'app-common-itemview',
  templateUrl: './common-item-view.component.html',
  styleUrls: ['./common-item-view.component.scss'],
  providers: [
    {
      provide: DynamicFormService,
      useFactory: injectedOrDefaultFormServiceFactory,
      deps: [
        [new Optional(), FORM_SERVICE_PROVIDER_TOKEN],
        [new Optional(), CoreConfigService]
      ]
    },
    { provide: ViewProviderDirective, useExisting: ItemViewProviderDirective }
  ]
})
export class CommonItemViewComponent extends PrimeNGCommonItemViewComponent {
  currentDetailView?: WindowInfo;

  override nonMatching(
    detailViews: DetailViewWindowInfo[]
  ): DetailViewWindowInfo[] {
    return super.nonMatching(detailViews) as DetailViewWindowInfo[];
  }

  override changeTab(tabIndexEvent: any): void {
    super.changeTab(tabIndexEvent);
    if (!this.hideFooter) {
      return;
    }
    this.detailViews$.pipe(take(1)).subscribe((detailViews) => {
      const totalAttrTabs = this.attrTabsAccordionsTree?.size || 0;
      const selectedTabIndex = this.activeTab;

      if (selectedTabIndex >= totalAttrTabs) {
        const nonMatchingViews = this.nonMatching(detailViews);
        this.currentDetailView =
          nonMatchingViews[selectedTabIndex - totalAttrTabs];
      } else {
        const attrTabsAccordionsArray = Array.from(
          this.attrTabsAccordionsTree.entries()
        );
        const [category] = attrTabsAccordionsArray[tabIndexEvent.index] || [];
        const matchedViews = this.matchDetailViewsToCategories(detailViews, {
          key: category
        });
        this.currentDetailView = matchedViews?.[0];
      }
      // za listView prikazujemo akcije
      // TODO obrisati klasu nakon sto se ova opcija prebaci u NTAP
      if (!this.currentDetailView.isItemView) {
        this.hideFooter = false;
      }
    });
  }
}
